'use client'

import React from 'react'

import type { SelectProps } from '~/core/ui/Select'
import { Select } from '~/core/ui/Select'

const NativeSelect = (
  props: SelectProps & { ref?: React.Ref<HTMLSelectElement> }
) => {
  const { ref, ...rest } = props
  return <Select ref={ref} {...rest} isMulti={false} />
}

NativeSelect.displayName = 'NativeSelect'

export { NativeSelect }
